<template>
	<div class="tours">
		<div>
			<b-card no-body>
				<b-tabs pills card vertical>
					<b-tab title="Consultar" active>
            <list-tours></list-tours>
					</b-tab>
					<b-tab title="Adicionar">
            <new-tour></new-tour>
					</b-tab>
				</b-tabs>
			</b-card>
		</div>
	</div>
</template>

<script>
import newTour from '../components/Tours/newTour.vue'
import listTours from '../components/Tours/listTours.vue'
export default {
	name: "tours",
	data() {
		return {
		}
	},
	components: {
    newTour,
    listTours
	}
}
</script>

<style lang='css'>
.tours a {
  color: #53574D !important;
}
</style>
